///
/// Link Component - React Router compatibility wrapper for Next.js Link
///
/// This component provides a similar API to next/link but uses React Router
///

import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom'
import { type ReactNode } from 'react'

interface LinkProps extends Omit<RouterLinkProps, 'to'> {
  href: string
  children: ReactNode
}

/**
 * Link component that mimics next/link but uses React Router under the hood
 */
export default function Link({ href, children, ...props }: LinkProps) {
  return (
    <RouterLink to={href} {...props}>
      {children}
    </RouterLink>
  )
}

